export default __webpack_public_path__ + "static/media/check.87cb1e0d.svg";